import { render, staticRenderFns } from "./PlayerStatus.vue?vue&type=template&id=b3d53e22&scoped=true"
import script from "./PlayerStatus.vue?vue&type=script&lang=js"
export * from "./PlayerStatus.vue?vue&type=script&lang=js"
import style0 from "./PlayerStatus.vue?vue&type=style&index=0&id=b3d53e22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3d53e22",
  null
  
)

export default component.exports